// One recommended next step per work-queue item (#118), so the planner does not have to choose
// from five equal buttons. Driver out of hours → reschedule; no answer yet → follow up;
// followed up and still silent → call. The reason is shown next to the button.
export function recommendAction(loading) {
  if (loading.state === 'no-power') return { action: 'replan', reason: 'noPower' };
  if (loading.urged) return { action: 'call', reason: 'noAnswer' };
  return { action: 'urge', reason: 'noInfo' };
}

export const ACTIONS = ['urge', 'call', 'link', 'replan', 'resolve'];
